import UserSettings from '@/vue/users/UserSettings.vue'

import OrganisationsRecord from '@/vue/organisations/OrganisationsRecord.vue'
import CommunicationOverview from '@/vue/communication/CommunicationOverview.vue'
import CommunicationRecord from '@/vue/communication/CommunicationRecord.vue'
import MailOverview from '@/vue/communication/MailOverview.vue'
import MailRecord from '@/vue/communication/MailRecord.vue'
import OnlineRentalSettings from '@/vue/online-rental/OnlineRentalSettings.vue'

export default [
    // User
    {
        path: '/panel/accountinstellingen',
        name: 'UserSettings',
        component: UserSettings
    },

    // Organisation
    {
        path: '/panel/instellingen/algemeen',
        name: 'OrganisationRecord',
        component: OrganisationsRecord
    },
    {
        path: '/panel/instellingen/communicatie',
        name: 'CommunicationOverview',
        component: CommunicationOverview
    },
    {
        path: '/panel/instellingen/communicatie/:id',
        name: 'CommunicationRecord',
        component: CommunicationRecord
    },
    {
        path: '/panel/instellingen/online-verhuur',
        name: 'OnlineRentalSettings',
        component: OnlineRentalSettings
    },
    {
        path: '/panel/mailen',
        name: 'MailOverview',
        component: MailOverview,
        meta: {
            dateRangeFilter: true,
            dateRangeFilterLabel: 'Verzenddatum bereik',
        }
    },
    {
        path: '/panel/mailen/:id',
        name: 'MailRecord',
        component: MailRecord
    }
]